exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alphabet_button[data-v-141e2139]{margin-right:1px;min-width:31px;color:#4d7cfe!important}.alphabet_button[data-v-141e2139]:disabled{color:#35495e!important}.btn-primary[data-v-141e2139]{color:#fff!important}.checkboxes[data-v-141e2139]{-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:55vh;-ms-flex-line-pack:start;align-content:flex-start;overflow-y:scroll}.font-blue[data-v-141e2139]{color:#4d7cfe!important}", ""]);

// exports
